import React, { useState, useEffect, useContext } from "react";
import { Alert, Box, Grid, TextField, Typography, Button, Paper, Checkbox, FormControlLabel, Tooltip } from '@mui/material';
import { Radio, RadioGroup, FormControl, FormLabel } from '@mui/material';
import { PayPalScriptProvider, PayPalButtons } from "@paypal/react-paypal-js";
import MenuItem from '@mui/material/MenuItem';
import Switch from '@mui/material/Switch';
import FormGroup from "@mui/material/FormGroup";
import InputLabel from '@mui/material/InputLabel';
import Select from '@mui/material/Select';
import successIcon from '../assets/payment-success-icon.png';
import PersonAddIcon from '@mui/icons-material/PersonAdd';
import DeleteIcon from '@mui/icons-material/Delete';
import IconButton from '@mui/material/IconButton';
import ChildCareComp from '../components/ChildCareComp'
import { useAuth } from '../hooks/useAuth';
import { useNavigate } from 'react-router-dom';
import { useMember } from '../context/MemberProfileContext';
import RetreatRulesComp from '../components/RetreatRulesComp'
import parse from 'html-react-parser';
// added imports for pretty breakdown table
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import { Card, CardContent} from '@mui/material';
import EventIcon from '@mui/icons-material/Event';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';


import PaymentComp from '../components/PaymentComp'
import PaypalComp from '../components/PaypalComp';
import { DataContext } from '../App';
import PaypalZelle from "../components/PaypalZelle";


export default function HoliWalkthon() {
    const [eventData, setEventData] = useState({
        "balaviharYear": "",
        "membershipType": {
            "name": ""
        },
        status: "",
        eventType: '',
        "notes": "first event1",
        "children": [
        ],
        "medical": {
            "pcpName": "",
            "pcpMobile": "",
            "medicalInsurance": "",
            "groupNo": "",
            "idNo": "",
            "medicalNotes": "",
            "medicalConsentSignedBy": "",
            "treatmentConsentSignedBy": ""
        },
        transaction: {
            quantities: 0,
            itemPrice: 0,
            totalAmount: "",
            donationAmount: "",
            payerId: "",
            notes: "Multiple Events",
        },
        tshirts: [{
            size: "",
            quantity: "0"
        }],
        "events": [
        ],
        feeEnabled: 0,
        parent: {
            firstName: "",
            lastName: "",
            email: "",
            mobileNumber: ""

        }
    });
    const { accessToken, signOut } = useAuth();
    const [eventTxnsHistory, setEventTxnsHistory] = useState();
    const [studentFields, setStudentFields] = useState([]);
    const [eventFields, setEventFields] = useState([]);
    const [childEventTypes, setChildEventTypes] = useState([]);    
    const [eventDescription, setEventDescription] = useState("");
    const [ticketPrice, setTicketPrice] = useState(0);
    const [eventTypeId, setEventTypeId] = useState(0);
    const [shirtFields, setShirtFields] = useState(eventData.tshirts);
    const [noOfShirts, setNoOfShirts] = useState(0);
    const [tshirtFlag, setTshirtFlag] = useState(false);
    const [tshirtPrice, setTshirtPrice] = useState(0);
    const [tshirtEventTypeId, setTshirtEventTypeId] = useState(null);
    const [holiPrice, setHoliPrice] = useState(0);
    const [holiEventTypeId, setHoliEventTypeId] = useState(null);
    const [holiFlag, setHoliFlag] = useState(true);
    
    

    const [sessions, setSessions] = useState();
    const [error, setError] = useState(null);
    const [rulesAccepted, setRulesAccepted] = useState(false); // State to manage checkbox
    const API_URL = process.env.REACT_APP_API_URL;
    const navigate = useNavigate();
    const { memberships, setMemberships} = useMember();
    const [parivarMember, setParivarMember] = useState(false);
    const [feeEnabled, setFeeEnabled] = useState(0);
    const [parivarEnabled, setParivarEnabled] = useState(0);

    const { memberProfile, setMemberProfile } = useMember();
    const { eventTypes, setEventTypes } = useMember ();
    const [inputFields, setInputFields] = useState(eventData.transaction);
    const [childFields, setChildFields] = useState(eventData.dayCare);
    const [medicalFields, setMedicalFields] = useState(eventData.medical); 
    const [fullNames, setFullNames] = useState(memberProfile.children.map((child) => child.fullName));
    const [donation, setDonation] = useState(0);
    const [totalAmount, setTotalAmount] = useState(inputFields.quantities * inputFields.itemPrice);
    const [noOfPeople, setNoOfPeople] = useState(eventData.transaction.quantities);
    const [eventDetails, setEventDetails] = useState(0);    
    const [memBvRegdReqd, setMemBvRegdReqd] = useState(); // Membership/Balavihar registration required for event
    const [addChild, setAddChild] = useState(eventData.parent.childCareReqd);

    useEffect(() => {

        console.log("Token exists or not :", accessToken);
    
        if (accessToken) {
            memberProfileFetch(); // Load membership data
            eventTxnsHistoryFetch();

        } else {
            signOut();
            navigate('/');
        }
      }, [accessToken])         // Empty dependency array ensures this runs once on mount;

            //Chinmaya Parivar Member
    const [payloadData, setPayloadData] = useState({});
    
    //to populate registered children

    
    const [email, setEmail] = useState("");
    useEffect(() => {        
        setEmail(memberProfile.primary.email); // Assign email from memberProfile
    }, [])         // Empty dependency array ensures this runs once on mount
    useEffect(() => {
            eventData.parent.firstName = memberProfile.primary.firstName;
            eventData.parent.lastName = memberProfile.primary.lastName;
            eventData.parent.email = memberProfile.primary.email;
            eventData.parent.mobileNumber = memberProfile.primary.mobileNumber.replace(/[-\s]/g, ''); // Remove hyphens and spaces    
        }, [])         // Empty dependency array ensures this runs once on mount 

    useEffect(() => {
        if (eventTypes && eventTypes.length > 0) {

            {
            // Find the eventTypeId of the record where name === 'Languages'
            //setLanguageEventType(eventTypes.find((eventType) => eventType.name === 'Language/Cultural Event'));
            const parentWalkathonEventType = eventTypes.find((eventType) => eventType.name === 'TshirtHoliWalkthon');
            if (parentWalkathonEventType) {
                const filteredEventTypes = eventTypes.filter(
                    (eventType) => eventType.parentEventTypeId === parentWalkathonEventType.eventTypeId
                );
                setChildEventTypes(filteredEventTypes);
                setEventDetails(parentWalkathonEventType);
                eventData.balaviharYear = String(parentWalkathonEventType.eventYear); // Set the balavihar year
                console.log("Filtered Child Event Types:", filteredEventTypes);
            
            // detect tshirt child event (name contains 'tshirt') and capture price
            const tshirtEvent = filteredEventTypes.find(et => et.name && et.name.toLowerCase().includes('tshirt'));
                if (tshirtEvent) {
                    setTshirtFlag(true);
                    setTshirtPrice(Number(tshirtEvent.price) || 0);
                    setTshirtEventTypeId(tshirtEvent.eventTypeId);
                    
                } else {
                    setTshirtFlag(false);
                    setTshirtPrice(0);
                    setTshirtEventTypeId(null);
                }
                // capture HoliWalkthon event price if it exists
                const holiEvent = eventTypes.find(et => et.name === 'HoliWalkthon');
                if (holiEvent) {
                    setHoliFlag(true);
                    setHoliPrice(Number(holiEvent.price) || 0);
                    setTicketPrice(Number(holiEvent.price) || 0);
                    setHoliEventTypeId(holiEvent.eventTypeId);

                    console.log('HoliWalkthon event found, price:', holiEvent.price);
                } else {
                    setHoliFlag(false);
                    setHoliPrice(0);
                    setHoliEventTypeId(null);
                }
                                // ensure eventData.events contains both tshirt and holi event entries (if present)
                /*const memberId = memberProfile?.primary?.memberId || null;
                const eventsArray = [];
                if (tshirtEvent && memberId) {
                    eventsArray.push({ memberId, eventTypeId: tshirtEvent.eventTypeId });
                }
                if (holiEvent && memberId) {
                    // avoid duplicate eventTypeId
                    if (!eventsArray.some(ev => ev.eventTypeId === holiEvent.eventTypeId)) {
                        eventsArray.push({ memberId, eventTypeId: holiEvent.eventTypeId });
                    }
                }
                // update state (use setter to ensure React state consistency)
                //setEventData(prev => ({ ...prev, balaviharYear: String(parentWalkathonEventType.eventYear), events: eventsArray }));
                setEventData(prev => ({ ...prev, events: eventsArray }));
                */
           
            } else {
                console.log("No event type found with the name 'TshirtHoliWalkthon'");
                setChildEventTypes([]); // Set to an empty array if no matching record is found
            }

        }
            
        } 
    }, [eventTypes]);


    const handleShirtSize = (e, index) => {
        let newForm = [...shirtFields];
        newForm[index][e.target.name] = e.target.value;
        setShirtFields(newForm);
        eventData.tshirts = newForm;
    }

    const handleShirtQuantity = (e, index) => {
        let newForm = [...shirtFields];
        newForm[index][e.target.name] = e.target.value;
        setShirtFields(newForm);
        eventData.tshirts = newForm;
        setNoOfShirts(e.target.value);
        let dummy = 0;
        eventData.tshirts.forEach((element) => { dummy = parseInt(dummy) + parseInt(element.quantity) }
        );

        setNoOfShirts(dummy);
    }

    const handleAddShirtFields = () => {
        setShirtFields([...shirtFields, { size: "", quantity: "" }]);
    };

    const handleRemoveShirtFields = (index) => {
        const values = [...shirtFields];
        values.splice(index, 1);
        setShirtFields(values);
        eventData.tshirts = values;
        let dummy = 0;
        eventData.tshirts.forEach((element) => { dummy = parseInt(dummy) + parseInt(element.quantity) }
        );

        setNoOfShirts(dummy);
    };

    const total = () => {
        inputFields.donationAmount = donation;
        inputFields.totalAmount = totalAmount;
        eventData.transaction = inputFields;
    }
    total();
    
    useEffect(() => {
            
        // Check for Parivar Member and set ticket price to 0 if true
        if (memberships.currentMembership && memberships.currentMembership.membershipTypesEntity.name.toLowerCase().includes('chinmaya parivar member')) {
            setTicketPrice(0);
        } 
        const shirtsTotal = noOfShirts * tshirtPrice;
        eventData.transaction.itemPrice = ticketPrice;
        eventData.transaction.quantities = noOfPeople + noOfShirts;

        if (feeEnabled) {
            setTotalAmount(((parseInt(noOfPeople) * parseInt(ticketPrice) + parseInt(donation) + parseInt(shirtsTotal)) * 1.03).toFixed(2));
        } else {
            setTotalAmount((parseInt(noOfPeople) * parseInt(ticketPrice) + parseInt(donation) + parseInt(shirtsTotal)) * 1.00);
        }

        eventData.transaction.totalAmount = totalAmount;
        // build events array only when corresponding quantities > 0
        const memberId = memberProfile?.primary?.memberId || null;
        const eventsArray = [];
        const ticketQty = parseInt(noOfPeople || 0, 10);
        const shirtsQty = parseInt(noOfShirts || 0, 10);
        if (memberId && holiEventTypeId && ticketQty > 0) {
            eventsArray.push({
                memberId,
                eventTypeId: holiEventTypeId,
                quantities: ticketQty
            });
        }
        if (memberId && tshirtEventTypeId && shirtsQty > 0) {
            eventsArray.push({
                memberId,
                eventTypeId: tshirtEventTypeId,
                quantities: shirtsQty
            });
        }
        // update eventData.events via setter to keep React state consistent
        setEventData(prev => ({ ...prev, events: eventsArray }));
        console.log("Run 1 calculate price :", eventData, (eventData.events), ticketPrice, totalAmount);

    }, [noOfPeople, noOfShirts, donation, feeEnabled, parivarEnabled, ticketPrice, memberships.totalAmountPaid, memberships.status, parivarMember]);


        
    const eventTxnsHistoryFetch = async () => {
        let response, data;
        try {
            const response = await fetch(`${API_URL}/gquery`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'x-cmdfw-jwt-token': `${accessToken}`,
                },
                body: JSON.stringify({
                    query: `
                            query {
                              eventsHistory {
                                  events {
                                      memEventsId
                                      status
                                      startDate
                                      endDate
                                      memberEntity {
                                          memberId
                                          memberType
                                          fullName
                                      }
                                      eventTypesEntity {
                                          eventTypeId
                                          name
                                          eventYear
                                      }
                                      transactionEntity {
                                          transactionId
                                          totalAmount
                                          paymentStatus
                                          createdAt
                                      }
                                  }
                                }
                            }
                          `,
                }),
            });

            const data = await response.json();
            if (response.ok) {
                console.log("Event history data API call:", response, data.data.eventsHistory.events);

                setEventTxnsHistory(data.data.eventsHistory.events);
            } else {
                if (response.status === 403) {
                    const errorData = await response.json();
                    throw new Error(errorData.message || 'OTP expired');
                    //handleLogout(); // Logout user
                } else {
                    if (!response.ok) {
                        const errorData = await response.json();
                        throw new Error(errorData.message || 'Membership fetch failed');
                    }
                }
            }
        } catch (error) {
            console.error("Error fetching Event Txns History :", error);
            //signOut();
            //navigate('/');
        }
    };

    function handlePeople(e) {
        setNoOfPeople(parseInt(e.target.value));
    }

    const handleLogout = () => {
        signOut();
        navigate('/');
      };

    const memberProfileFetch = async () => {
        console.log("Membership profile fetch", accessToken);
        let response, data;
        try {    
          //const response = await fetch('https://membership.cmdfw.org/api/gquery', {
          const response = await fetch(`${API_URL}/gquery`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'x-cmdfw-jwt-token': `${accessToken}`,
            },
              body: JSON.stringify({
                  query: `
                          query {
                            memberships {
                                balaviharYear
                                balaviharPeriod
                                status
                                totalAmountPaid
                                membershipTypes {
                                    membershipTypeId
                                    name
                                    startDate
                                    endDate
                                    bvPrice
                                    childQuantities
                                }
                                availableSessions {
                                    sessionId
                                    center
                                    sessionName
                                    grades {
                                        gradeId
                                        grade
                                    }
                                }
                                registeredSessions{
                                    bvRegistrationId
                                    regStartDate
                                    regEndDate
                                    status
                                    memberEntity{
                                        firstName
                                        lastName
                                        fullName
                                    }
                                    sessionEntity {
                                        sessionId
                                        center
                                        sessionName
                                    }
                                    gradeEntity{
                                        gradeId
                                        grade
                                    }
                                }
                                currentMembership {
                                    membershipId
                                    startDate
                                    endDate
                                    status
                                    notes
                                    bvYear
                                    createdAt 
                                    createdBy 
                                    membershipTypesEntity{
                                        membershipTypeId
                                        name
                                        startDate
                                        endDate
                                    }
                                    transactionEntity {
                                        transactionId
                                        eventTypesEntity {
                                            eventTypeId
                                            name
                                            eventYear
                                        }
                                        totalAmount
                                        paymentStatus
                                        createdAt 
                                        createdBy 
                                    }
                                }
                            }
                          }
                        `,
            }),
          });
    
          const data = await response.json();
          if (response.ok) {
            setMemberships(data.data.memberships);
            console.log("Membership data after API call:", data, response);
          } else {
            if (response.status === 403) {
              const errorData = await response.json();
              handleLogout(); // Logout user
              throw new Error(errorData.message || 'OTP expired');
            } else {
              if (!response.ok) {
                const errorData = await response.json();
                throw new Error(errorData.message || 'Membership fetch failed');
              }
            }
          }
        } catch (error) {
          console.error("Error fetching Membership Profile :", error);
          signOut();
          //navigate('/');
        }
      };
     

    const checkoutHandler = (e) => {
        e.preventDefault();
        setError(null);
        // Skip payment if total amount is zero
        if (totalAmount >0 ) {        
            eventData.status = "pending";
        } else {
            eventData.status = "paid";
            setSuccess(true); // Skip payment if total amount is zero
        }
        setPayloadData(eventData); 

        //    console.log("transaction before sent to SQS:", (inputFields));
        if (sendToServer()) {
            console.log("checkout true");
            //setCheckout(true);
        } else {
            //setCheckout(false);
            console.log("checkout false");
        }
    };
    async function sendToServer() {
        const maxRetries = 3; // Maximum number of retries
        let attempt = 0;
        let url_link = `${API_URL}/events`;
        console.log("transaction before sent to Database:", eventData, url_link);


        while (attempt < maxRetries) {
            try {
            //const response = await fetch(`${API_URL}/events`, {
            const response = await fetch(url_link, {
                method: "POST",
                headers: {
                    'Content-Type': 'application/json',
                    "x-cmdfw-jwt-token": `${accessToken}`,
                },
                body: JSON.stringify(eventData),
            });
            console.log('API response:', response.data);
            if (response.ok) {
                setCheckout(true);
                return true; // Success
            }
            if (response.status === 403) {
                const errorData = await response.json();
                handleLogout(); // Logout user
                throw new Error(errorData.message || 'OTP expired');
              } else {
                const errorData = await response.json();
                console.error('API Error:', errorData);
                setError(errorData.message);
                return false; // API call failed
                //throw new Error(errorData.message || 'API call failed');
            }
        } catch (error) {
            console.error(`Attempt ${attempt + 1} failed:`, error);
            attempt++;

            if (attempt >= maxRetries) {
                console.error('All retry attempts failed.');
                setCheckout(false);
                setError("Failed to send data to the server. Please try again later.");
                return false; // Return false after all retries fail
            }

            console.log(`Retrying API call... (${attempt}/${maxRetries})`);
 
        }
    }
    }


    function feeSwitchHandler(e) {
        setError(null); // Clear any existing errors
        setFeeEnabled(e.target.checked);
        eventData.feeEnabled = e.target.checked ;
    }
    function checkOutEnableHandler(e) {
        setError(null); // Clear any existing errors
        setRulesAccepted(e.target.checked)
    }
    function handleBack() {
        setCheckout(false);
    }

    function handleDonation(e) {
        setInputFields({ ...inputFields, [e.target.name]: parseInt(e.target.value) });
        if (e.target.value >= 0) {
            setDonation(parseInt(e.target.value));
        }
    };

    const handleCancel = () => {
        navigate('/EventTypesForm');
        // Add any additional save logic here, such as API calls
      };

        const initialOptions = {
            clientId: process.env.REACT_APP_PROD_CLIENT_ID,
            currency: "USD",
            intent: "capture",
            "disable-funding": "paylater",
        };
    
        const [errorMessage, setErrorMessage] = useState('')
        const [orderId, setOrderId] = useState(false)
    
    const createOrder = (data, actions) => {
        var itemArray = [];

        if (eventData.transaction.quantities > 0 || noOfShirts > 0) {
            itemArray[itemArray.length] = {
                name: "TShirt, Holi Walkathon event amount",
                description: "TShirt, Holi Walkathon event amount",
                unit_amount: {
                    currency_code: "USD",
                    value: "" + (parseInt(noOfShirts) * parseInt(tshirtPrice) + parseInt(noOfPeople) * parseInt(ticketPrice)),
                },
                quantity: "1",
            }
        }
        if (eventData.transaction.donationAmount > 0) {
            itemArray[itemArray.length] = {
                name: "Donation Amount",
                description: "Donation item",
                unit_amount: {
                    currency_code: "USD",
                    value: eventData.transaction.donationAmount,
                },
                quantity: "1",
            }
        }
        if (feeEnabled > 0) {
            itemArray[itemArray.length] = {
                name: "Credit Card processing Fee Amount",
                description: "Credit Card Fee item",
                unit_amount: {
                    currency_code: "USD",
                    value: ((parseInt(noOfShirts) * parseInt(tshirtPrice) + parseInt(noOfPeople) * parseInt(ticketPrice) + parseInt(eventData.transaction.donationAmount)) * 0.03).toFixed(2),
                },
                quantity: "1",
            }
        }

        console.log('items array in create order 21:', itemArray, eventData.transaction.totalAmount, eventData.transaction.donationAmount, noOfPeople, noOfShirts, eventData.transaction.quantities);
        return actions.order.create({
            purchase_units: [
                {
                    description: "T-shirt Walkathon Event",
                    amount: {
                        value: eventData.transaction.totalAmount,
                        currency_code: "USD",
                        breakdown: {
                            item_total: {
                                value: eventData.transaction.totalAmount,
                                currency_code: "USD",
                            }
                        }
                    },

                    items: itemArray, /**/
                },
            ],
            payer: {
                name: {
                given_name: eventData.parent.firstName, // First Name from the form
                surname: eventData.parent.lastName // Last Name from the form
                },
                email_address: eventData.parent.email, //paymentData.parent.email,
                phone: {
                phone_type: "MOBILE",  // Specify it's a mobile number
                phone_number: {
                    national_number: eventData.parent.mobileNumber  // Mobile number
                }
                },
            }
        })
            .then((orderId) => {
                setOrderId(orderId)
                return orderId
            })
    }
    const onApprove = (data, actions) => {
        return actions.order.capture().then(function (details) {
            const { payer } = details
            setSuccess(true);
            setCheckout(true);
            eventData.transaction.paymentStatus = 'paid';
            eventData.status = "paid";
            eventData.transaction.payerId = payer.payer_id;
            console.log('on Approve Event data : ', eventData);
            sendToServer();
        })
    }
    const onError = (data, actions) => {
        setErrorMessage("An error occured with your payment")
    }
 
    const [success, setSuccess] = useState(false)
    const [checkout, setCheckout] = useState(false)

// add these computed line-item values before return
    const ticketQtyNum = parseInt(noOfPeople || 0, 10);
    const ticketUnit = parseFloat(ticketPrice || 0);
    const ticketAmount = Number((ticketQtyNum * ticketUnit).toFixed(2));

    const shirtsQtyNum = parseInt(noOfShirts || 0, 10);
    const shirtUnit = parseFloat(tshirtPrice || 0);
    const shirtsAmount = Number((shirtsQtyNum * shirtUnit).toFixed(2));

    const donationAmountNum = Number(parseFloat(donation || 0).toFixed(2));

    const subtotal = Number((ticketAmount + shirtsAmount + donationAmountNum).toFixed(2));
    const feeAmount = feeEnabled ? Number((subtotal * 0.03).toFixed(2)) : 0;
    const computedTotal = Number((subtotal + feeAmount).toFixed(2));
    return (
        <div>
            <Grid item xs={12} sm={12}>
                    <Typography variant="h6" align="center" gutterBottom>
                        {'CMDFW Registration System'}
                    </Typography>
                </Grid>

            <form onSubmit={checkoutHandler}>
                <Grid container direction="column" alignItems="center" >
                    {
                        checkout ?
                            success  ?
                                <Grid item>
                                    <img src={successIcon} className="Success-icon" alt="logo" />
                                    <Typography variant="h5" align="center" gutterBottom>
                                        {'Thank You for the Registration'}
                                    </Typography>
                                    <Box sx={{ width: '100%', maxWidth: 500 }}>
                                        <Typography variant="body2" align="left" gutterBottom>
                                            You will receive an email confirmation to this address <b> [ {email} ] </b>
                                        </Typography>
                                    </Box>
                                </Grid>
                                :
                                
                                <Grid item>
                                    <PayPalScriptProvider options={initialOptions}>
                                        <Box sx={{ width: { xs: '100%', sm: 520 }, maxWidth: '100%' }}>
                                            <PayPalButtons
                                                style={{ layout: "vertical", label: "pay", height: 35 }}
                                                createOrder={createOrder}
                                                onApprove={onApprove}
                                            />
                                        </Box>
                                    </PayPalScriptProvider>

                                    <span>
                                        <Button type="submit" variant="contained" sx={{ mt: 3, mb: 2 }} onClick={() => handleBack()}>Back</Button>
                                    </span>
                                </Grid>
                            :
                            <div>
                                
                                <div><br /></div>
                                <Grid item xs={12} sm={12}>
                                    <Grid item xs={12}>
                                        <Card elevation={0} sx={{ mb: 4, border: '1px solid #e0e0e0' }}>
                                            <CardContent sx={{ p: 4 }}>
                                                <Box sx={{ display: 'flex', alignItems: 'center', mb: 3 }}>
                                                    <EventIcon sx={{ color: '#667eea', mr: 2, fontSize: 28 }} />
                                                    <Typography variant="h5" sx={{ fontWeight: 600, color: '#2c3e50' }}>
                                                        Event Information
                                                    </Typography>
                                                </Box>
                                                <Box sx={{
                                                    p: 3,
                                                    backgroundColor: '#f8f9fa',
                                                    borderRadius: 2,
                                                    border: '1px solid #e9ecef',
                                                    mb: 3
                                                }}>
                                                    <Typography variant="body1" sx={{ lineHeight: 1.6, color: '#495057', alignItems: 'left' }}>
                                                        {eventDetails.desc ? parse(eventDetails.desc) : "Loading event details..."}
                                                    </Typography>
                                                </Box>

                                                {memberships.status === "ACTIVE" ? (
                                                    <Box sx={{
                                                        p: 3,
                                                        backgroundColor: '#d4edda',
                                                        borderRadius: 2,
                                                        border: '1px solid #c3e6cb',
                                                        display: 'flex',
                                                        alignItems: 'center'
                                                    }}>
                                                        <CheckCircleIcon sx={{ color: '#155724', mr: 2 }} />
                                                        <Box>
                                                            <Typography variant="body1" sx={{ fontWeight: 600, color: '#155724' }}>
                                                                Membership Status: Active
                                                            </Typography>
                                                            <Typography variant="body2" sx={{ color: '#155724' }}>
                                                                Period: {memberships.balaviharPeriod} | Type: {memberships.currentMembership?.membershipTypesEntity?.name}
                                                            </Typography>
                                                        </Box>
                                                    </Box>
                                                ) : (
                                                    <Alert severity="warning" sx={{ mb: 2 }}>
                                                        <Typography variant="body2">
                                                            <strong>Membership expired.</strong> Please renew your membership for the period: {memberships.balaviharPeriod}
                                                        </Typography>
                                                    </Alert>
                                                )}
                                            </CardContent>
                                        </Card>
                                    </Grid>


                                
                                </Grid>
                                <div><br /></div>
                                
                                <Paper elevation={3}>                                
                                        <Grid item xs={12} sm={12}>
                                        <Paper elevation={3}>
                                            {tshirtFlag && (
                                            <Paper style={{ padding: '16px', backgroundColor: '#673ab7', color: 'white' }} elevation={3}>
                                                <Typography variant="h7" align="left" gutterBottom>
                                                    <b>T Shirt</b>
                                                </Typography>
                                            </Paper>
                                            )}
                                    <div><br /></div>

                                    {tshirtFlag && shirtFields.map((shirtFields, index) => (
                                    <div key={index} align="left">
                                        <Grid container spacing={4} >
                                            <Grid item xs={5} sm={4}>
                                                <FormControl variant="standard" sx={{ m: 1, minWidth: '100px' }} size="small">
                                                    <InputLabel id="demo-simple-select-standard-label"> Size</InputLabel>
                                                    <Select
                                                        id="standard"
                                                        name="size"
                                                        value={shirtFields.size}
                                                        onChange={(e) => handleShirtSize(e, index)}
                                                        label="Shirtsize"

                                                    >
                                                        <MenuItem value="Adult-XL">Adult-XL</MenuItem>
                                                        <MenuItem value="Adult-L">Adult-L</MenuItem>
                                                        <MenuItem value="Adult-M">Adult-M</MenuItem>
                                                        <MenuItem value="Adult-S">Adult-S</MenuItem>
                                                        <MenuItem value="Youth-L">Youth-L</MenuItem>
                                                        <MenuItem value="Youth-M">Youth-M</MenuItem>
                                                        <MenuItem value="Youth-S">Youth-S</MenuItem>
                                                        <MenuItem value="Youth-XS">Youth-XS</MenuItem>
                                                    </Select>
                                                </FormControl>
                                            </Grid>
                                            <Grid item xs={3} sm={3}>
                                                <TextField
                                                    number
                                                    id="noOfShirts"
                                                    label="# of Shirts"
                                                    style={{ m: 1, minWidth: '100px' }}
                                                    inputProps={{ min: 0, max: 10 }}
                                                    type="number"
                                                    name="quantity"
                                                    variant="standard"
                                                    value={shirtFields.quantity}
                                                    onChange={(e) => handleShirtQuantity(e, index)}
                                                />
                                            </Grid>
                                            <Grid item xs={4} sm={3}>
                                                {index >= 1 ?
                                                    <IconButton onClick={() => handleRemoveShirtFields(index)}>
                                                        <DeleteIcon />
                                                    </IconButton> : ''
                                                }
                                                <IconButton onClick={() => handleAddShirtFields(index)}>
                                                    <PersonAddIcon />
                                                </IconButton>
                                            </Grid>
                                        </Grid>
                                    </div>
                                ))}
                                        </Paper>
                                        <div><br /></div>

                                        <Paper elevation={3}>
                                            <Paper style={{ padding: '16px', backgroundColor: '#673ab7', color: 'white' }} elevation={3}>
                                                <Typography variant="h7" align="left" gutterBottom>
                                                    <b>Holi Walkathon </b>
                                                </Typography>
                                            </Paper>
                                        </Paper>
                                        <div><br /></div>

                                        <Paper elevation={3}>
                                            <TextField
                                                    fullWidth
                                                    number
                                                    id="tickets"
                                                    label="Enter Number of Tickets"
                                                    type="number"
                                                    inputProps={{ min: 0, max: 20 }}
                                                    name="quantities"
                                                    variant="outlined"
                                                    value={noOfPeople}
                                                    onChange={handlePeople}
                                                />
                                            
                                            </Paper>
                                        </Grid>
                                    </Paper>
                                <div><br /></div>
                                                                                       
                                {
                                (memBvRegdReqd && memberships.status === "ACTIVE") || !memBvRegdReqd ? (  
                                <Grid item xs={12} sm={12}>                  
                                <div><br /></div>
                                <Paper elevation={3}>
                                        <Paper style={{ padding: '16px', backgroundColor: '#673ab7', color: 'white' }} elevation={3}>
                                        <Typography variant="h7" align="left" gutterBottom>
                                            <b>Payment Information</b>
                                        </Typography>
                                </Paper>
                                <div><br /></div>
                                
                                <div><br /></div>
                                <Grid container direction="row" spacing={2} >
                                    <Grid item xs={12} sm={6}>
                                        <TextField
                                            fullWidth
                                            number
                                            id="donation"
                                            label="Additional Donation ($)"
                                            type="number"
                                            name="donation"
                                            variant="standard"
                                            value={donation}
                                            onChange={handleDonation}
                                        />
                                    </Grid>
                                    <Grid item xs={12} sm={12}>
                                        <FormGroup>
                                            <FormControlLabel control={<Checkbox checked={feeEnabled} />} label="Add 3% to cover for CC fees"
                                                value={feeEnabled} size="small" onChange={feeSwitchHandler} />
                                        </FormGroup>
                                    </Grid>
                                     {/* prettier payment breakdown table */}
                                    <Grid item xs={12} sm={12} sx={{ mt: 1 }}>
                                                                          {/* Floating total amount box styled like payment info */}
                                        <Box
                                            sx={{
                                                width: '100%',
                                                borderRadius: 2,
                                                bgcolor: 'background.paper',
                                                transition: 'transform 200ms ease, box-shadow 200ms ease, border-color 200ms ease',
                                                border: '2px solid transparent',
                                                '&:hover': {
                                                    transform: 'translateY(-6px)',
                                                    borderColor: 'primary.main',
                                                    boxShadow: 6
                                                },
                                                p: 1.25
                                            }}
                                        >
                                            {/* small header to match Payment Information styling */}
                                            <Paper elevation={0} sx={{ bgcolor: '#673ab7', color: 'white', px: 1.5, py: 0.75, borderRadius: 1 }}>
                                                <Typography variant="subtitle2"><b>Payment Summary</b></Typography>
                                            </Paper>
                                        <TableContainer component={Paper} variant="outlined" sx={{ overflow: 'hidden' }}>
                                            <Table size="small" aria-label="payment breakdown">
                                                <TableHead>
                                                    <TableRow>
                                                        <TableCell
                                                            sx={{
                                                                bgcolor: '#f3f4f6',
                                                                color: 'text.primary',
                                                                fontWeight: 800,
                                                                textTransform: 'uppercase',
                                                                letterSpacing: '0.08em',
                                                                borderBottom: '2px solid rgba(0,0,0,0.08)'
                                                            }}
                                                        >
                                                            Item
                                                        </TableCell>
                                                        <TableCell
                                                            align="right"
                                                            sx={{
                                                                bgcolor: '#f3f4f6',
                                                                color: 'text.primary',
                                                                fontWeight: 800,
                                                                textTransform: 'uppercase',
                                                                letterSpacing: '0.08em',
                                                                borderBottom: '2px solid rgba(0,0,0,0.08)'
                                                            }}
                                                        >
                                                            Unit
                                                        </TableCell>
                                                        <TableCell
                                                            align="right"
                                                            sx={{
                                                                bgcolor: '#f3f4f6',
                                                                color: 'text.primary',
                                                                fontWeight: 800,
                                                                textTransform: 'uppercase',
                                                                letterSpacing: '0.08em',
                                                                borderBottom: '2px solid rgba(0,0,0,0.08)'
                                                            }}
                                                        >
                                                            Qty
                                                        </TableCell>
                                                        <TableCell
                                                            align="right"
                                                            sx={{
                                                                bgcolor: '#f3f4f6',
                                                                color: 'text.primary',
                                                                fontWeight: 800,
                                                                textTransform: 'uppercase',
                                                                letterSpacing: '0.08em',
                                                                borderBottom: '2px solid rgba(0,0,0,0.08)'
                                                            }}
                                                        >
                                                            Amount
                                                        </TableCell>
                                                    </TableRow>
                                                </TableHead>
                                                <TableBody>
                                                    {ticketQtyNum > 0 && (
                                                        <TableRow>
                                                            <TableCell>Holi Walkathon</TableCell>
                                                            <TableCell align="right">${ticketUnit.toFixed(2)}</TableCell>
                                                            <TableCell align="right">{ticketQtyNum}</TableCell>
                                                            <TableCell align="right">${ticketAmount.toFixed(2)}</TableCell>
                                                        </TableRow>
                                                    )}
                                                    {shirtsQtyNum > 0 && (
                                                        <TableRow>
                                                            <TableCell>T-Shirt</TableCell>
                                                            <TableCell align="right">${shirtUnit.toFixed(2)}</TableCell>
                                                            <TableCell align="right">{shirtsQtyNum}</TableCell>
                                                            <TableCell align="right">${shirtsAmount.toFixed(2)}</TableCell>
                                                        </TableRow>
                                                    )}
                                                    {donationAmountNum > 0 && (
                                                        <TableRow>
                                                            <TableCell>Additional Donation</TableCell>
                                                            <TableCell align="right">—</TableCell>
                                                            <TableCell align="right">1</TableCell>
                                                            <TableCell align="right">${donationAmountNum.toFixed(2)}</TableCell>
                                                        </TableRow>
                                                    )}
                                                    {feeAmount > 0 && (
                                                        <TableRow>
                                                            <TableCell>Credit Card Fee (3%)</TableCell>
                                                            <TableCell align="right">—</TableCell>
                                                            <TableCell align="right">1</TableCell>
                                                            <TableCell align="right">${feeAmount.toFixed(2)}</TableCell>
                                                        </TableRow>
                                                    )}


                                                    <TableRow>
                                                        <TableCell colSpan={3} align="right"><Typography sx={{ fontWeight: 900, fontSize: 16 }}>Total</Typography></TableCell>
                                                        <TableCell align="right"><Typography sx={{ fontWeight: 900, fontSize: 16 }}>${computedTotal.toFixed(2)}</Typography></TableCell>
                                                    </TableRow>
                                                </TableBody>
                                            </Table>
                                        </TableContainer>

                                                            <Grid item xs={12}>
                                                                <Box sx={{
                                                                    p: 1,
                                                                    background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                                                                    borderRadius: 4,
                                                                    color: 'white',
                                                                    textAlign: 'center',
                                                                    border: '2px solid rgba(255, 255, 255, 0.2)'
                                                                }}>
                                                                    <Typography variant="h5" sx={{ fontWeight: 700 }}>
                                                                        Total Amount: ${totalAmount}
                                                                    </Typography>
                                                                </Box>
                                                            </Grid>


                                        </Box>
                                    </Grid>
                                </Grid>
                                </Paper>

                                <div><br /></div>
                                <Grid container direction="row" spacing={5}>
                                    <Grid item>
                                        <Typography variant="body2" align="center" gutterBottom>
                                        <b>Waiver Statement (Please read and agree to the waiver statement before you proceed) :</b> <a href="https://membership.cmdfw.org/docs/cmdfw-waiver.pdf" target="_blank" rel="noopener noreferrer"> Open PDF </a>
                                        </Typography>
                                    </Grid>
                                </Grid>
                                <Grid container direction="row" spacing={5}>
                                    <Grid item>
                                        <FormControlLabel
                                            control={
                                                <Checkbox
                                                    checked={rulesAccepted}
                                                    onChange={checkOutEnableHandler}
                                                    name="rulesAccepted"
                                                    color="primary"
                                                />
                                            }
                                            label="I accept the rules and policies"
                                        />
                                    </Grid>
                                </Grid>

                                <Grid container direction="row" spacing={2}>
                                    
                                    <Grid item>
                                        <Button onClick={handleCancel} variant="contained" sx={{ mt: 3, mb: 2 }}>Cancel</Button>
                                    </Grid>
                                    <Grid item>
                                    <Tooltip title={!rulesAccepted ? "Please accept the rules and policies" : ""}>
                                        <span>
                                        <Button type="submit" variant="contained" sx={{ mt: 3, mb: 2 }} disabled={!rulesAccepted}>Checkout</Button>
                                        </span>
                                    </Tooltip>
                                    </Grid>
                                    {error && (
                                        <Grid item xs={12}>
                                            <Alert severity="error">{error}</Alert>
                                        </Grid>
                                    )}
                                </Grid>
                                    <Grid container direction="row" spacing={5}>
                                    <Grid item>
                                        <Typography variant="body2" align="center" gutterBottom>
                                            If you have any questions, please contact us at <a href="mailto:membership@cmdfw.org">membership@cmdfw.org</a>
                                        </Typography>
                                    </Grid>
                                </Grid>
                                </Grid> ) : "" }
                            </div> 
                    }
                </Grid>
            </form>
        </div >
    );
}